<template>
  <RwvAuthor :author="author" :isAuthenticated="isAuthenticated"/>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";
import { FETCH_AUTHOR } from "@/store/actions.type";
import RwvAuthor from "@/components/Author";

export default {
  title () {
    return `${this.author.name.title} ${this.author.name.name} ${this.author.name.surname} | So wird's gemacht`
  },
  components: {
    RwvAuthor
  },
  props: {
    slug: {
      type: String
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.slug == null || to.params.slug == "") {
      console.log("unknown slug")
    }
      console.log(to.params.slug)

    Promise.all([
      store.dispatch(
        FETCH_AUTHOR,
        {
          slug: to.params.slug
        }
      ),
    ]).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters(["author", "isAuthenticated"])
  },
}
</script>

<style>
</style>
